import { Alert, Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useGetParticipantFeedbackContextQuery } from '../../colleagueRating/api/colleagueFeedbackApi';

type ParticipantFeedbackContextProps = {
  reviewId: number;
};

const formatDate = (value?: string) => {
  if (!value) return '';
  const [date] = value.split('T');
  const [year, month, day] = date.split('-');
  return year && month && day ? `${day}.${month}.${year}` : value;
};

export const ParticipantFeedbackContext = ({ reviewId }: ParticipantFeedbackContextProps) => {
  const { data, isLoading, isError } = useGetParticipantFeedbackContextQuery(reviewId, {
    skip: !Number.isInteger(reviewId) || reviewId <= 0,
  });

  if (isLoading) {
    return <CircularProgress size={20} sx={{ mb: 2 }} />;
  }

  if (isError) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        Unable to load the reviewed employee and review period.
      </Alert>
    );
  }

  if (!data) return null;

  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: 'background.paper',
      }}
    >
      <Stack spacing={0.5}>
        <Typography variant="body2">
          <strong>Reviewed Employee:</strong> {data.ReviewedEmployeeName}
        </Typography>
        <Typography variant="body2">
          <strong>Review Period:</strong> {formatDate(data.PeriodFrom)} -{' '}
          {formatDate(data.PeriodTo)}
        </Typography>
      </Stack>
    </Box>
  );
};
